import React, {useEffect, useState} from 'react';
import 'antd/dist/antd.less';
import './Layout.css';
import {
  Breadcrumb,
  Drawer,
  Layout as AntLayout,
  Menu,
  Space,
  Switch,
} from 'antd';
import {useOutlet, useOutletSetter} from 'reconnect.js';
import * as UserActions from 'rev.sdk.js/Actions/User';
import LoginForm from 'rev.sdk.js/Components/LoginForm';
import {Dashboard} from '@styled-icons/zondicons/Dashboard';
import {ShoppingBag} from '@styled-icons/boxicons-solid/ShoppingBag';
import {LogOut} from '@styled-icons/boxicons-regular/LogOut';
import {Helmet} from 'react-helmet';
import styled from 'styled-components';

const {Content, Footer, Sider} = AntLayout;
const {SubMenu} = Menu;

function Layout(props) {
  const {path} = props;
  const [actions] = useOutlet('actions');
  const [user] = useOutlet('user');
  const showLoginModal = useOutletSetter('login-modal');
  const [collapsed, setCollapsed] = useState(false);
  const [currentKey, setCurrentKey] = useState('');
  const [admin, setAdmin] = useState(path.indexOf('admin') > -1);

  useEffect(() => {
    const init = async () => {
      try {
        actions.setLoading(true);
        await UserActions.autoLogin({refresh: null, admin: admin});
      } catch (err) {
        console.warn('auto login fail');
        await UserActions.logout(admin);
      } finally {
        actions.setLoading(false);
      }
    };
    init();
  }, [actions, admin]);

  if (!user) {
    return (
      <AntLayout
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Helmet>
          <title>rev.sdk.js</title>
        </Helmet>
        <Space direction="vertical" align="center">
          <LoginForm
            admin={admin}
            adminFormTitle={'REV ADMIN 登入'}
            formTitle={<h2 style={{color: '#444'}}>登入</h2>}
            canFacebookLogin
            canLineLogin
            canGoogleLogin
            onBeforeLoginClick={(type, data) => {
              console.log(type, data);
              return true;
            }}
            renderExtra={({admin}) => {
              return admin ? null : (
                <p
                  style={{
                    marginBottom: 10,
                    color: '#444',
                    fontSize: 13,
                    textAlign: 'center',
                  }}>
                  * 請使用 pokemon 帳號登入
                </p>
              );
            }}
          />
          <Switch
            size="default"
            onChange={(checked) => {
              setAdmin(checked);
            }}
            checkedChildren="admin"
            unCheckedChildren="ec"
            defaultChecked={admin}
          />
        </Space>
      </AntLayout>
    );
  }

  const onCollapse = (_collapsed) => {
    setCollapsed(_collapsed);
  };

  const MenuStruct = [
    {
      key: 'admin',
      name: 'Admin',
      icon: <Dashboard size={16} />,
      children: [
        {
          key: 'admin_home',
          name: 'AdminHome',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/admin', {loading: 800});
          },
        },
        {
          key: 'admin_admin-resource',
          name: 'AdminResource',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/admin/example_using', {loading: true});
          },
        },
        {
          key: 'admin_articles',
          name: 'Articles',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/admin/articles', {loading: true});
          },
        },
        {
          key: 'admin_products',
          name: 'Products',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/admin/products', {loading: true});
          },
        },
        {
          key: 'admin_orders',
          name: 'Orders',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/admin/orders', {loading: true});
          },
        },
        {
          key: 'admin_antdtable-filter',
          name: 'AntdTable',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/admin/antd-table-filter', {
              loading: false,
            });
          },
        },
      ],
    },
    {
      key: 'ec',
      name: 'E-Commerce',
      icon: <ShoppingBag size={16} />,
      children: [
        {
          key: 'ec_product-list',
          name: 'ProductList',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/products', {loading: true});
          },
        },
        {
          key: 'ec_article-list',
          name: 'ArticleList',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/articles', {loading: true});
          },
        },
        {
          key: 'ec_register-request',
          name: 'Register Request',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/register/request', {loading: 800});
          },
        },
        {
          key: 'ec_checkout',
          name: 'Checkout(cart)',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/checkout', {loading: 800});
          },
        },
        {
          key: 'ec_checkout_info',
          name: 'Checkout(info)',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/checkout/info', {loading: 800});
          },
        },
        {
          key: 'ec_checkout_review',
          name: 'Checkout(review)',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/checkout/review', {loading: 800});
          },
        },

        {
          key: 'ec_product-variants',
          name: 'Product Variants',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/product-variants');
          },
        },
        {
          key: 'ec_order',
          name: 'OrderList',
          onClick: async (key) => {
            setCurrentKey(key);
            await actions.navigate('/profile/orders', {loading: 800});
          },
        },
      ],
    },
    {
      key: 'logout',
      name: 'Logout',
      icon: <LogOut size={16} />,
      onClick: async () => {
        await UserActions.logout(admin);
      },
      children: [],
    },
  ];

  return (
    <AntLayout style={{minHeight: '100vh'}}>
      <Helmet>
        <title>rev.sdk.js</title>
      </Helmet>
      <Drawer
        title="rev.sdk.js"
        placement="left"
        onClose={() => {
          onCollapse(false);
        }}
        visible={collapsed}>
        <div className="logo" />
        <Menu theme="light" defaultSelectedKeys={[]} mode="inline">
          {MenuStruct.map((menu) => {
            if (menu.children.length > 0) {
              return (
                <SubMenu icon={menu.icon} key={menu.key} title={menu.name}>
                  {menu.children.map((sm) => (
                    <Menu.Item
                      onClick={async () => {
                        if (sm.onClick) {
                          await sm.onClick(sm.key);
                          onCollapse(false);
                        }
                      }}
                      key={sm.key}>
                      {sm.name}
                    </Menu.Item>
                  ))}
                </SubMenu>
              );
            } else {
              return (
                <Menu.Item
                  onClick={async () => {
                    if (menu.onClick) {
                      await menu.onClick(menu.key);
                      onCollapse(false);
                    }
                  }}
                  icon={menu.icon}
                  key={menu.key}>
                  {menu.name}
                </Menu.Item>
              );
            }
          })}
        </Menu>
      </Drawer>
      <AntLayout className="site-layout">
        <CircleButton
          onClick={() => {
            onCollapse(true);
          }}>
          <Dashboard size={30} color="#fff"></Dashboard>
        </CircleButton>
        <Content style={{margin: '0 16px'}}>
          <Breadcrumb style={{margin: '16px 0'}}>
            {currentKey.split('_').map((s, index) => (
              <Breadcrumb.Item key={index}>{s}</Breadcrumb.Item>
            ))}
          </Breadcrumb>
          <Wrapper>{props.children}</Wrapper>
        </Content>
        <Footer style={{textAlign: 'center'}}>
          Revtel © 2022 Dev Demo Site
        </Footer>
      </AntLayout>
    </AntLayout>
  );
}

const Wrapper = styled.div`
  padding: 24px;
  min-height: 360px;

  #rev-ProductListPage {
    & .rev-mobile-menu-btn {
      & > button {
        display: none;
      }

      &::before {
        display: block;
        content: 'FILTER';
        padding: 8px 16px;
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
        background-color: white;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.5);
        cursor: pointer;
      }
    }
  }

  #rev-CheckoutReviewPage {
    & .point {
      & > label {
        display: none;
      }

      ::before {
        content: '紅利';
      }
    }
  }
`;

const CircleButton = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 300ms ease;
  z-index: 100;
  &:hover {
    transform: scale(1.2);
  }
`;

export default Layout;
